// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--LUPMU","postfix":"_25d45facb5--postfix--C8ah3"};